module.exports = __webpack_public_path__ + "media/images/steps/step_1-65f77af6363568c88e22dfe9fb38ab21.svg";